import React, { FC } from 'react';
import OverviewText from './components/overviewText';
import OverviewCarousel from './components/overviewCarousel';
import { TContentHubSeriesOverviewProps } from './types/productSeriesOverview.types';
import { Element } from 'react-scroll';
import { isEmptyResponse } from '../../utils/checkEmptyResponse';
import useExperiencerEditorPlaceholder from '../../hooks/useExperiencerEditorPlaceholder';
import ExperienceEditorComponentPlaceholder from '../@shared/experienceEditorComponentPlaceholder';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import { isEditorActive, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import AnalyticsVisibleEvent from '../@shared/analyticsVisibleEvent';

const ProductSeriesOverview: FC<TContentHubSeriesOverviewProps> = (props) => {
  const apiResponse = isEmptyResponse(props);
  const isPlaceholderShown = useExperiencerEditorPlaceholder(props);

  // Component is unreleased
  if (props?.fields?.isComponentUnreleased) {
    return <UnreleasedComponent />;
  }

  //  star node opened directly in EE
  if (isPlaceholderShown) {
    return (
      <ExperienceEditorComponentPlaceholder image={props?.fields?.itemData?.thumbnail} componentName={props?.rendering?.componentName} />
    );
  }

  // not opened from star node
  // data missing when navigating via from products node
  if (!apiResponse && isEditorActive()) {
    return <EmptyApiDataMessage componentName={props?.rendering?.componentName} />;
  }

  // No data and not in EE
  if (!apiResponse && !isPlaceholderShown && !isEditorActive()) {
    return null;
  }

  return (
    <AnalyticsVisibleEvent
      rendering={props?.rendering}
      title={props.fields?.apiData.title ?? props.fields?.apiData.eyebrow}
      template="Series Overview"
    >
      <Element name="Overview">
        <section className="series-overview">
          <div className="series-overview__container">
            <OverviewCarousel {...props} />
            <OverviewText {...props} />
          </div>
        </section>
      </Element>
    </AnalyticsVisibleEvent>
  );
};

export default withSitecoreContext()(ProductSeriesOverview);
